import "@hotwired/turbo-rails";
import "../custom_actions";

window.Turbo.config.forms.mode = "optin";
